import React, { Component } from "react";
import axios from "axios";
import constants from "../../Constants";

const baseURL = constants.baseURL;

const VEHICLE_TYPES = [
  "1.5 Ton",
  "4 Ton",
  "8 Ton",
  "14 Ton",
  "Bakkie / LDV",
  "Other",
];

const VISIT_REASONS = [
  "General enquiry",
  "Account assistance",
  "Vehicle registration",
  "Payment query",
  "Technical support",
  "Training / onboarding",
  "Other",
];

const ACCENT = "#34D1BF";
const ACCENT_DARK = "#2AB5A5";
const ACCENT_LIGHT = "rgba(52,209,191,0.08)";
const ACCENT_TINT = "rgba(52,209,191,0.15)";
const GRAY_900 = "#212529";
const GRAY_600 = "#6C757D";
const GRAY_400 = "#ADB5BD";
const GRAY_200 = "#E9ECEF";
const GRAY_100 = "#F8F9FA";
const RADIUS = "14px";
const RADIUS_SM = "10px";
const TRANSITION = "all 0.2s cubic-bezier(.4,0,.2,1)";

// Date helpers
const DAY_NAMES_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const formatDateNice = (dateStr) => {
  const d = new Date(dateStr + "T00:00:00");
  return `${DAY_NAMES_SHORT[d.getDay()]}, ${d.getDate()} ${MONTH_NAMES[d.getMonth()]}`;
};

const formatTimeTo12h = (t) => {
  const [h, m] = t.split(":");
  const hour = parseInt(h, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  const h12 = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
  return `${h12}:${m} ${ampm}`;
};

class BookingSection extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(window.location.search);
    const now = new Date();
    this.inviteToken = params.get("token") || "";
    this.state = {
      // auth
      tokenVerified: false,
      tokenError: "",
      // 1=date, 2=time, 3=details, 4=review, 5=success, 6=manage
      step: 1,
      loading: false,
      error: "",
      selectedDate: "",
      selectedTime: "",
      slots: [],
      slotsLoading: false,
      dayBlocked: false,
      driverName: "",
      driverSurname: "",
      phone: "",
      email: "",
      driverId: "",
      vehicleType: "",
      reasonForVisit: "",
      booking: null,
      cancelEmail: "",
      myBookings: [],
      myBookingsLoading: false,
      cancelSuccess: "",
      cancellingId: null,
      // Calendar state
      calMonth: now.getMonth(),
      calYear: now.getFullYear(),
    };
  }

  componentDidMount() {
    if (!this.inviteToken) {
      this.setState({ tokenError: "no_token" });
      return;
    }
    axios
      .get(`${baseURL}/office-visit/verify-token?token=${encodeURIComponent(this.inviteToken)}`)
      .then((res) => {
        if (res.data.valid) {
          this.setState({
            tokenVerified: true,
            driverId: res.data.driverId || "",
          });
        } else {
          this.setState({ tokenError: res.data.error || "invalid" });
        }
      })
      .catch((err) => {
        const msg = err.response?.data?.error || "Unable to verify your invite link.";
        this.setState({ tokenError: msg });
      });
  }

  authHeaders = () => ({ headers: { Authorization: `Bearer ${this.inviteToken}` } });

  getMinDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toISOString().split("T")[0];
  };

  getMaxDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + 30);
    return d.toISOString().split("T")[0];
  };

  isWeekend = (dateStr) => {
    const d = new Date(dateStr + "T00:00:00");
    return d.getDay() === 0 || d.getDay() === 6;
  };

  getNextWeekdays = () => {
    // not used anymore — kept for compat
    return [];
  };

  calPrevMonth = () => {
    this.setState((prev) => {
      let m = prev.calMonth - 1;
      let y = prev.calYear;
      if (m < 0) { m = 11; y--; }
      return { calMonth: m, calYear: y };
    });
  };

  calNextMonth = () => {
    this.setState((prev) => {
      let m = prev.calMonth + 1;
      let y = prev.calYear;
      if (m > 11) { m = 0; y++; }
      return { calMonth: m, calYear: y };
    });
  };

  getCalendarDays = () => {
    const { calMonth, calYear } = this.state;
    const firstDay = new Date(calYear, calMonth, 1).getDay(); // 0=sun
    const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
    const cells = [];
    // empty leading cells
    for (let i = 0; i < firstDay; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);
    return cells;
  };

  isDateSelectable = (day) => {
    if (!day) return false;
    const { calMonth, calYear } = this.state;
    const dateStr = `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    const d = new Date(dateStr + "T00:00:00");
    const dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    const min = this.getMinDate();
    const max = this.getMaxDate();
    return dateStr >= min && dateStr <= max;
  };

  dateFromDay = (day) => {
    const { calMonth, calYear } = this.state;
    return `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  };

  fetchSlots = (date) => {
    if (!date || this.isWeekend(date)) {
      this.setState({ slots: [], selectedTime: "", dayBlocked: false });
      return;
    }
    this.setState({ slotsLoading: true, selectedTime: "", error: "" });
    axios
      .get(`${baseURL}/office-visit/available-slots?date=${date}`, this.authHeaders())
      .then((res) => {
        this.setState({
          slots: res.data.slots || [],
          dayBlocked: res.data.dayBlocked || false,
          slotsLoading: false,
        });
      })
      .catch(() => {
        this.setState({ slotsLoading: false, error: "Could not load available slots. Please try again." });
      });
  };

  handleDateSelect = (date) => {
    this.setState({ selectedDate: date, error: "", step: 2 });
    this.fetchSlots(date);
  };

  handleTimeSelect = (time) => {
    this.setState({ selectedTime: time, step: 3, error: "" });
  };

  handleSubmit = () => {
    const { driverName, driverSurname, phone, email, vehicleType, reasonForVisit, selectedDate, selectedTime } = this.state;
    if (!driverName || !driverSurname || !phone || !email) {
      this.setState({ error: "Please fill in all required fields." });
      return;
    }
    this.setState({ loading: true, error: "" });
    axios
      .post(`${baseURL}/office-visit/book`, {
        driverName, driverSurname, phone, email, vehicleType, reasonForVisit,
        driverId: this.state.driverId,
        date: selectedDate, time: selectedTime,
      }, this.authHeaders())
      .then((res) => {
        this.setState({ loading: false, step: 5, booking: res.data.booking });
      })
      .catch((err) => {
        const msg = err.response?.data?.error || "Booking failed. The slot may have been taken.";
        this.setState({ loading: false, error: msg });
        this.fetchSlots(selectedDate);
      });
  };

  handleCancelLookup = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    this.setState({ myBookingsLoading: true, error: "", cancelSuccess: "" });
    axios
      .get(`${baseURL}/office-visit/my-bookings`, this.authHeaders())
      .then((res) => {
        this.setState({ myBookings: res.data || [], myBookingsLoading: false });
      })
      .catch(() => {
        this.setState({ myBookingsLoading: false, error: "Could not look up bookings." });
      });
  };

  handleCancelBooking = (bookingId) => {
    this.setState({ cancellingId: bookingId, cancelSuccess: "" });
    axios
      .post(`${baseURL}/office-visit/cancel`, { bookingId }, this.authHeaders())
      .then(() => {
        this.setState({ cancelSuccess: "Booking cancelled successfully.", cancellingId: null });
        this.handleCancelLookup();
      })
      .catch(() => {
        this.setState({ cancellingId: null, error: "Could not cancel booking." });
      });
  };

  goBack = () => {
    const { step } = this.state;
    if (step > 1 && step < 5) {
      this.setState({ step: step - 1, error: "" });
    }
  };

  resetForm = () => {
    this.setState({
      step: 1, booking: null, selectedDate: "", selectedTime: "",
      vehicleType: "", reasonForVisit: "", error: "",
    });
  };

  /* ═══════════════════ STEP 1: DATE ═══════════════════ */
  renderDateStep = () => {
    const { selectedDate, calMonth, calYear } = this.state;
    const cells = this.getCalendarDays();
    const monthLabel = `${MONTH_NAMES[calMonth]} ${calYear}`;
    const today = new Date();
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    const dayHeaders = ["S", "M", "T", "W", "T", "F", "S"];

    return (
      <div style={{ animation: "fadeSlideUp 0.35s ease" }}>
        <div style={stepHeaderStyle}>
          <span style={stepIconStyle}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </span>
          <div>
            <h3 style={stepTitleStyle}>Pick a date</h3>
            <p style={stepSubStyle}>Mon – Fri, 9 AM – 3 PM</p>
          </div>
        </div>

        {/* Month navigation */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
          <button type="button" onClick={this.calPrevMonth} style={{ background: "none", border: `1.5px solid ${GRAY_200}`, borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", WebkitTapHighlightColor: "transparent" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={GRAY_900} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <span style={{ fontSize: "17px", fontWeight: "700", color: GRAY_900 }}>{monthLabel}</span>
          <button type="button" onClick={this.calNextMonth} style={{ background: "none", border: `1.5px solid ${GRAY_200}`, borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", WebkitTapHighlightColor: "transparent" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={GRAY_900} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>

        {/* Day-of-week headers */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px", marginBottom: "6px" }}>
          {dayHeaders.map((h, i) => (
            <div key={i} style={{ textAlign: "center", fontSize: "13px", fontWeight: "700", color: (i === 0 || i === 6) ? GRAY_400 : GRAY_600, padding: "6px 0" }}>{h}</div>
          ))}
        </div>

        {/* Calendar grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px", marginBottom: "12px" }}>
          {cells.map((day, idx) => {
            if (day === null) return <div key={`e${idx}`} />;
            const dateStr = this.dateFromDay(day);
            const selectable = this.isDateSelectable(day);
            const isSelected = selectedDate === dateStr;
            const isToday = dateStr === todayStr;
            const d = new Date(dateStr + "T00:00:00");
            const isWeekend = d.getDay() === 0 || d.getDay() === 6;

            return (
              <button
                key={idx}
                type="button"
                disabled={!selectable}
                className="ov-cal-cell"
                onClick={() => selectable && this.handleDateSelect(dateStr)}
                style={{
                  width: "100%",
                  aspectRatio: "1",
                  minHeight: "44px",
                  border: isSelected ? `2.5px solid ${ACCENT}` : isToday ? `1.5px solid ${ACCENT}` : "1.5px solid transparent",
                  borderRadius: "12px",
                  background: isSelected ? ACCENT : "transparent",
                  cursor: selectable ? "pointer" : "default",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: TRANSITION,
                  WebkitTapHighlightColor: "transparent",
                  padding: 0,
                  opacity: selectable ? 1 : isWeekend ? 0.25 : 0.35,
                }}
              >
                <span style={{
                  fontSize: "16px",
                  fontWeight: isSelected || isToday ? "700" : "500",
                  color: isSelected ? "#fff" : isToday ? ACCENT : isWeekend ? GRAY_400 : GRAY_900,
                  lineHeight: 1,
                }}>{day}</span>
              </button>
            );
          })}
        </div>

        <p style={{ color: GRAY_400, fontSize: "13px", textAlign: "center", margin: "0" }}>Tap a weekday to continue</p>
      </div>
    );
  };

  /* ═══════════════════ STEP 2: TIME ═══════════════════ */
  renderTimeStep = () => {
    const { slots, selectedTime, slotsLoading, dayBlocked, selectedDate } = this.state;

    if (slotsLoading) {
      return (
        <div style={{ textAlign: "center", padding: "40px 0", animation: "fadeSlideUp 0.35s ease" }}>
          <div style={spinnerStyle} />
          <p style={{ color: GRAY_600, marginTop: "16px", fontSize: "15px" }}>Finding available times...</p>
        </div>
      );
    }

    if (dayBlocked) {
      return (
        <div style={{ textAlign: "center", padding: "40px 20px", animation: "fadeSlideUp 0.35s ease" }}>
          <div style={{ fontSize: "40px", marginBottom: "12px" }}>&#128683;</div>
          <p style={{ color: GRAY_900, fontSize: "16px", fontWeight: "600" }}>This day is unavailable</p>
          <p style={{ color: GRAY_600, fontSize: "14px", margin: "8px 0 20px" }}>Please go back and choose a different date.</p>
          <button type="button" onClick={this.goBack} style={secondaryBtnStyle}>Choose another date</button>
        </div>
      );
    }

    const available = slots.filter((s) => s.available);
    const unavailable = slots.filter((s) => !s.available);

    return (
      <div style={{ animation: "fadeSlideUp 0.35s ease" }}>
        <div style={stepHeaderStyle}>
          <span style={stepIconStyle}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </span>
          <div>
            <h3 style={stepTitleStyle}>Choose a time</h3>
            <p style={stepSubStyle}>{formatDateNice(selectedDate)}</p>
          </div>
        </div>

        {available.length === 0 ? (
          <div style={{ textAlign: "center", padding: "30px 0" }}>
            <p style={{ color: GRAY_600, fontSize: "15px" }}>No slots available on this date.</p>
            <button type="button" onClick={this.goBack} style={{ ...secondaryBtnStyle, marginTop: "16px" }}>Choose another date</button>
          </div>
        ) : (
          <>
            <div className="ov-time-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "12px" }}>
              {slots.map((slot) => {
                const isActive = selectedTime === slot.time;
                const gone = !slot.available;
                return (
                  <button
                    type="button"
                    key={slot.time}
                    disabled={gone}
                    onClick={() => this.handleTimeSelect(slot.time)}
                    style={{
                      padding: "20px 10px",
                      border: isActive ? `2px solid ${ACCENT}` : `1.5px solid ${gone ? GRAY_200 : GRAY_200}`,
                      borderRadius: RADIUS,
                      background: gone ? GRAY_100 : isActive ? ACCENT_LIGHT : "#fff",
                      cursor: gone ? "default" : "pointer",
                      transition: TRANSITION,
                      opacity: gone ? 0.5 : 1,
                      WebkitTapHighlightColor: "transparent",
                      position: "relative",
                    }}
                  >
                    <span style={{ fontSize: "15px", fontWeight: isActive ? "700" : "500", color: gone ? GRAY_400 : isActive ? ACCENT : GRAY_900, display: "block" }}>
                      {formatTimeTo12h(slot.time)}
                    </span>
                    {gone && <span style={{ fontSize: "10px", color: GRAY_400, display: "block", marginTop: "2px" }}>Taken</span>}
                    {isActive && <span style={{ position: "absolute", top: "6px", right: "6px", width: "8px", height: "8px", borderRadius: "50%", background: ACCENT }} />}
                  </button>
                );
              })}
            </div>
            {unavailable.length > 0 && (
              <p style={{ color: GRAY_400, fontSize: "12px", textAlign: "center", marginTop: "12px" }}>{unavailable.length} slot{unavailable.length > 1 ? "s" : ""} already taken</p>
            )}
          </>
        )}
      </div>
    );
  };

  /* ═══════════════════ STEP 3: DETAILS ═══════════════════ */
  renderDetailsStep = () => {
    const { driverName, driverSurname, phone, email, vehicleType, reasonForVisit, error, selectedDate, selectedTime } = this.state;
    return (
      <div style={{ animation: "fadeSlideUp 0.35s ease" }}>
        <div style={stepHeaderStyle}>
          <span style={stepIconStyle}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          </span>
          <div>
            <h3 style={stepTitleStyle}>Your details</h3>
            <p style={stepSubStyle}>{formatDateNice(selectedDate)} at {formatTimeTo12h(selectedTime)}</p>
          </div>
        </div>

        <div className="ov-name-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>First name *</label>
            <input type="text" value={driverName} onChange={(e) => this.setState({ driverName: e.target.value })} style={inputStyle} autoComplete="given-name" required />
          </div>
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>Surname *</label>
            <input type="text" value={driverSurname} onChange={(e) => this.setState({ driverSurname: e.target.value })} style={inputStyle} autoComplete="family-name" required />
          </div>
        </div>
        <div style={fieldGroupStyle}>
          <label style={labelStyle}>Phone *</label>
          <input type="tel" value={phone} onChange={(e) => this.setState({ phone: e.target.value })} style={inputStyle} placeholder="081 234 5678" autoComplete="tel" required />
        </div>
        <div style={fieldGroupStyle}>
          <label style={labelStyle}>Email *</label>
          <input type="email" value={email} onChange={(e) => this.setState({ email: e.target.value })} style={inputStyle} autoComplete="email" required />
        </div>
        <div style={fieldGroupStyle}>
          <label style={labelStyle}>Vehicle type <span style={{ color: GRAY_400, fontWeight: "400" }}>(optional)</span></label>
          <select value={vehicleType} onChange={(e) => this.setState({ vehicleType: e.target.value })} style={inputStyle}>
            <option value="">Select...</option>
            {VEHICLE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div style={fieldGroupStyle}>
          <label style={labelStyle}>Reason for visit <span style={{ color: GRAY_400, fontWeight: "400" }}>(optional)</span></label>
          <select value={reasonForVisit} onChange={(e) => this.setState({ reasonForVisit: e.target.value })} style={inputStyle}>
            <option value="">Select...</option>
            {VISIT_REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>

        {error && <div style={errorBannerStyle}>{error}</div>}

        <button type="button" onClick={() => {
          const { driverName, driverSurname, phone, email } = this.state;
          if (!driverName || !driverSurname || !phone || !email) {
            this.setState({ error: "Please fill in all required fields." });
            return;
          }
          this.setState({ step: 4, error: "" });
        }} style={primaryBtnStyle}>
          Review booking
        </button>
      </div>
    );
  };

  /* ═══════════════════ STEP 4: REVIEW ═══════════════════ */
  renderReviewStep = () => {
    const { selectedDate, selectedTime, driverName, driverSurname, phone, email, vehicleType, reasonForVisit, loading, error } = this.state;
    const rows = [
      { label: "Date", value: formatDateNice(selectedDate) },
      { label: "Time", value: formatTimeTo12h(selectedTime) },
      { label: "Name", value: `${driverName} ${driverSurname}` },
      { label: "Phone", value: phone },
      { label: "Email", value: email },
    ];
    if (vehicleType) rows.push({ label: "Vehicle", value: vehicleType });
    if (reasonForVisit) rows.push({ label: "Reason", value: reasonForVisit });

    return (
      <div style={{ animation: "fadeSlideUp 0.35s ease" }}>
        <div style={stepHeaderStyle}>
          <span style={stepIconStyle}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          </span>
          <div>
            <h3 style={stepTitleStyle}>Confirm your visit</h3>
            <p style={stepSubStyle}>Review details below</p>
          </div>
        </div>

        <div style={{ background: GRAY_100, borderRadius: RADIUS, overflow: "hidden" }}>
          {rows.map((r, i) => (
            <div key={r.label} className="ov-review-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: i < rows.length - 1 ? `1px solid ${GRAY_200}` : "none" }}>
              <span style={{ color: GRAY_600, fontSize: "14px" }}>{r.label}</span>
              <span style={{ color: GRAY_900, fontSize: "14px", fontWeight: "600", textAlign: "right", maxWidth: "60%", wordBreak: "break-word" }}>{r.value}</span>
            </div>
          ))}
        </div>

        {error && <div style={{ ...errorBannerStyle, marginTop: "16px" }}>{error}</div>}

        <button type="button" disabled={loading} onClick={this.handleSubmit} style={{ ...primaryBtnStyle, marginTop: "20px", position: "relative" }}>
          {loading ? (
            <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
              <span style={{ ...spinnerStyleSmall }} /> Booking...
            </span>
          ) : "Confirm & Book"}
        </button>

        <button type="button" onClick={() => this.setState({ step: 3 })} style={{ ...ghostBtnStyle, marginTop: "10px" }}>
          Edit details
        </button>
      </div>
    );
  };

  /* ═══════════════════ STEP 5: SUCCESS ═══════════════════ */
  renderSuccess = () => {
    const { booking } = this.state;
    return (
      <div style={{ textAlign: "center", animation: "fadeSlideUp 0.4s ease" }}>
        <div style={{ width: "80px", height: "80px", borderRadius: "50%", background: ACCENT_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        </div>
        <h3 style={{ fontSize: "22px", fontWeight: "700", color: GRAY_900, margin: "0 0 8px" }}>You're all set!</h3>
        <p style={{ color: GRAY_600, fontSize: "15px", margin: "0 0 24px", lineHeight: "1.5" }}>
          Your office visit is confirmed.{"\n"}A confirmation email is on its way.
        </p>

        {booking && (
          <div style={{ background: GRAY_100, borderRadius: RADIUS, padding: "20px", textAlign: "left", marginBottom: "24px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
              <span style={{ color: GRAY_600, fontSize: "14px" }}>Date</span>
              <span style={{ color: GRAY_900, fontWeight: "600", fontSize: "14px" }}>{formatDateNice(booking.date)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
              <span style={{ color: GRAY_600, fontSize: "14px" }}>Time</span>
              <span style={{ color: GRAY_900, fontWeight: "600", fontSize: "14px" }}>{formatTimeTo12h(booking.time)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: GRAY_600, fontSize: "14px" }}>Name</span>
              <span style={{ color: GRAY_900, fontWeight: "600", fontSize: "14px" }}>{booking.driverName} {booking.driverSurname}</span>
            </div>
            <div style={{ borderTop: `1px solid ${GRAY_200}`, marginTop: "14px", paddingTop: "10px" }}>
              <span style={{ color: GRAY_400, fontSize: "12px" }}>Ref: {booking.id}</span>
            </div>
          </div>
        )}

        <button type="button" onClick={this.resetForm} style={primaryBtnStyle}>Book another visit</button>
        <button type="button" onClick={() => { this.setState({ step: 6, error: "" }); setTimeout(() => this.handleCancelLookup(), 100); }} style={{ ...ghostBtnStyle, marginTop: "10px" }}>
          Manage my bookings
        </button>
      </div>
    );
  };

  /* ═══════════════════ STEP 6: MANAGE ═══════════════════ */
  renderManage = () => {
    const { myBookings, myBookingsLoading, error, cancelSuccess, cancellingId } = this.state;
    const STATUS_CONFIG = {
      booked: { bg: ACCENT_TINT, color: ACCENT_DARK, label: "Upcoming" },
      completed: { bg: "rgba(52,152,219,0.1)", color: "#2980b9", label: "Completed" },
      cancelled: { bg: GRAY_100, color: GRAY_400, label: "Cancelled" },
      no_show: { bg: "rgba(231,76,60,0.1)", color: "#c0392b", label: "No show" },
    };

    return (
      <div style={{ animation: "fadeSlideUp 0.35s ease" }}>
        <div style={stepHeaderStyle}>
          <span style={stepIconStyle}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
          </span>
          <div>
            <h3 style={stepTitleStyle}>My bookings</h3>
            <p style={stepSubStyle}>View or cancel your bookings</p>
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
          <button type="button" disabled={myBookingsLoading} onClick={() => this.handleCancelLookup()} style={{ ...primaryBtnStyle, width: "auto", padding: "0 24px", marginTop: 0, whiteSpace: "nowrap", minHeight: "50px" }}>
            {myBookingsLoading ? (
              <span style={{ display: "flex", alignItems: "center", gap: "8px" }}><span style={{ ...spinnerStyleSmall, borderTopColor: "#fff", borderColor: "rgba(255,255,255,.3)" }} /> Loading...</span>
            ) : (
              <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                Refresh
              </span>
            )}
          </button>
        </div>

        {error && <div style={errorBannerStyle}>{error}</div>}
        {cancelSuccess && (
          <div style={{ background: ACCENT_LIGHT, borderRadius: RADIUS_SM, padding: "12px 16px", marginBottom: "16px", color: ACCENT_DARK, fontSize: "14px", fontWeight: "500" }}>
            {cancelSuccess}
          </div>
        )}

        {myBookings.length > 0 && myBookings.map((b) => {
          const cfg = STATUS_CONFIG[b.status] || STATUS_CONFIG.booked;
          const isCancelling = cancellingId === b.id;
          return (
            <div key={b.id} style={{ border: `1.5px solid ${GRAY_200}`, borderRadius: RADIUS, padding: "16px", marginBottom: "12px", transition: TRANSITION }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                    <span style={{ fontSize: "15px", fontWeight: "700", color: GRAY_900 }}>{formatDateNice(b.visit_date)}</span>
                    <span style={{ fontSize: "14px", color: GRAY_600 }}>{formatTimeTo12h(b.visit_time)}</span>
                  </div>
                  <p style={{ margin: 0, color: GRAY_600, fontSize: "13px" }}>{b.driver_name} {b.driver_surname}</p>
                </div>
                <span style={{ padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", background: cfg.bg, color: cfg.color, flexShrink: 0 }}>
                  {cfg.label}
                </span>
              </div>
              {b.status === "booked" && (
                <button
                  type="button"
                  disabled={isCancelling}
                  onClick={() => this.handleCancelBooking(b.id)}
                  style={{ marginTop: "12px", width: "100%", padding: "11px", border: "1.5px solid #E74C3C", borderRadius: RADIUS_SM, background: "transparent", color: "#E74C3C", fontSize: "14px", fontWeight: "600", cursor: "pointer", transition: TRANSITION, opacity: isCancelling ? 0.6 : 1, WebkitTapHighlightColor: "transparent" }}
                >
                  {isCancelling ? "Cancelling..." : "Cancel this booking"}
                </button>
              )}
            </div>
          );
        })}

        {myBookings.length === 0 && !myBookingsLoading && (
          <div style={{ textAlign: "center", padding: "30px 0", color: GRAY_400 }}>
            <p style={{ fontSize: "15px" }}>No bookings found.</p>
          </div>
        )}
      </div>
    );
  };

  /* ═══════════════════ PROGRESS BAR ═══════════════════ */
  renderProgress = () => {
    const { step } = this.state;
    if (step >= 5) return null;
    const steps = [
      { num: 1, label: "Date" },
      { num: 2, label: "Time" },
      { num: 3, label: "Details" },
      { num: 4, label: "Confirm" },
    ];
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0", marginBottom: "28px" }}>
        {steps.map((s, i) => {
          const isActive = step === s.num;
          const isDone = step > s.num;
          return (
            <React.Fragment key={s.num}>
              {i > 0 && (
                <div className="ov-progress-line" style={{ width: "28px", height: "2px", background: isDone ? ACCENT : GRAY_200, transition: TRANSITION, margin: "0 2px" }} />
              )}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                <div style={{
                  width: "32px", height: "32px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
                  background: isDone ? ACCENT : isActive ? ACCENT : GRAY_200,
                  color: isDone || isActive ? "#fff" : GRAY_400,
                  fontSize: "13px", fontWeight: "700", transition: TRANSITION,
                }}>
                  {isDone ? (
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  ) : s.num}
                </div>
                <span style={{ fontSize: "11px", fontWeight: isActive ? "700" : "500", color: isActive ? ACCENT : isDone ? ACCENT_DARK : GRAY_400, letterSpacing: "0.3px" }}>{s.label}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  render() {
    const { step, tokenVerified, tokenError } = this.state;

    // ── Access denied / loading states ──
    if (tokenError) {
      const isNoToken = tokenError === "no_token";
      return (
        <section style={{ paddingTop: "90px", paddingBottom: "40px", minHeight: "100vh", background: `linear-gradient(180deg, ${GRAY_100} 0%, #fff 40%)` }}>
          <div style={{ maxWidth: "440px", margin: "0 auto", padding: "0 20px", textAlign: "center" }}>
            <div style={{ background: "#fff", borderRadius: "18px", padding: "40px 28px", boxShadow: "0 2px 16px rgba(0,0,0,0.06), 0 0 1px rgba(0,0,0,0.08)", marginTop: "40px" }}>
              <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "rgba(231,76,60,0.08)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#E74C3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
              </div>
              <h2 style={{ fontSize: "20px", fontWeight: "700", color: GRAY_900, margin: "0 0 8px" }}>
                {isNoToken ? "Invite Required" : "Access Denied"}
              </h2>
              <p style={{ color: GRAY_600, fontSize: "15px", lineHeight: "1.55", margin: "0 0 24px" }}>
                {isNoToken
                  ? "This page is only accessible via an invite link sent to your email. Please check your inbox for the QikTruck office visit invitation."
                  : typeof tokenError === "string" && tokenError.length > 2 ? tokenError : "Your invite link is invalid or has expired. Please contact support@qiktruck.co.za for a new invite."}
              </p>
              <a href="mailto:support@qiktruck.co.za" style={{ display: "inline-block", padding: "14px 28px", background: ACCENT, color: "#fff", borderRadius: RADIUS, fontSize: "15px", fontWeight: "600", textDecoration: "none" }}>
                Contact Support
              </a>
            </div>
          </div>
        </section>
      );
    }

    if (!tokenVerified) {
      return (
        <section style={{ paddingTop: "90px", paddingBottom: "40px", minHeight: "100vh", background: `linear-gradient(180deg, ${GRAY_100} 0%, #fff 40%)` }}>
          <div style={{ textAlign: "center", paddingTop: "80px" }}>
            <div style={{ width: "32px", height: "32px", border: `3px solid ${GRAY_200}`, borderTopColor: ACCENT, borderRadius: "50%", animation: "spin 0.7s linear infinite", margin: "0 auto" }} />
            <p style={{ color: GRAY_600, marginTop: "16px", fontSize: "15px" }}>Verifying your invite...</p>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        </section>
      );
    }

    const showBack = step > 1 && step < 5;
    const showManageLink = step < 5 && step !== 6;

    return (
      <section style={{ paddingTop: "90px", paddingBottom: "40px", minHeight: "100vh", background: `linear-gradient(180deg, ${GRAY_100} 0%, #fff 40%)` }}>
        <style>{`
          @keyframes fadeSlideUp {
            from { opacity: 0; transform: translateY(16px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          input:focus, select:focus {
            border-color: ${ACCENT} !important;
            box-shadow: 0 0 0 3px ${ACCENT_TINT} !important;
          }
          /* Hide scrollbar */
          ::-webkit-scrollbar { width: 0; height: 0; }

          /* ── Responsive overrides ── */
          .ov-outer { max-width: 500px; margin: 0 auto; padding: 0 20px; }
          .ov-card { padding: 28px 24px; }
          .ov-back-btn { position: absolute; left: 16px; top: 100px; }
          .ov-name-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
          .ov-time-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
          .ov-cal-cell { min-height: 44px; aspect-ratio: 1; border-radius: 12px; }
          .ov-manage-form { display: flex; gap: 10px; }
          .ov-review-row { padding: 14px 18px; }
          .ov-progress-line { width: 28px; }

          @media (max-width: 420px) {
            .ov-outer { padding: 0 12px !important; }
            .ov-card { padding: 20px 16px !important; }
            .ov-back-btn { left: 8px !important; top: 96px !important; width: 36px !important; height: 36px !important; }
            .ov-name-grid { grid-template-columns: 1fr !important; gap: 0 !important; }
            .ov-time-grid { gap: 8px !important; }
            .ov-cal-cell { min-height: 38px !important; border-radius: 10px !important; font-size: 14px !important; }
            .ov-manage-form { flex-direction: column !important; }
            .ov-review-row { padding: 12px 14px !important; }
            .ov-progress-line { width: 20px !important; }
          }

          @media (max-width: 360px) {
            .ov-card { padding: 16px 12px !important; }
            .ov-cal-cell { min-height: 34px !important; border-radius: 8px !important; }
            .ov-time-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>

        <div className="ov-outer" style={{ maxWidth: "500px", margin: "0 auto", padding: "0 20px" }}>
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "24px" }}>
            {showBack && (
              <button type="button" className="ov-back-btn" onClick={this.goBack} style={{ position: "absolute", left: "16px", top: "100px", background: "#fff", border: `1.5px solid ${GRAY_200}`, borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", WebkitTapHighlightColor: "transparent", zIndex: 10 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={GRAY_900} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
              </button>
            )}
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: GRAY_900, margin: "0 0 4px", letterSpacing: "-0.3px" }}>Office Visit</h2>
            <p style={{ color: GRAY_600, fontSize: "14px", margin: 0 }}>QikTruck HQ</p>
          </div>

          {/* Progress */}
          {step <= 4 && this.renderProgress()}

          {/* Card */}
          <div className="ov-card" style={{ background: "#fff", borderRadius: "18px", padding: "28px 24px", boxShadow: "0 2px 16px rgba(0,0,0,0.06), 0 0 1px rgba(0,0,0,0.08)" }}>
            {step === 1 && this.renderDateStep()}
            {step === 2 && this.renderTimeStep()}
            {step === 3 && this.renderDetailsStep()}
            {step === 4 && this.renderReviewStep()}
            {step === 5 && this.renderSuccess()}
            {step === 6 && this.renderManage()}
          </div>

          {/* Manage link */}
          {showManageLink && (
            <button
              type="button"
              onClick={() => this.setState({ step: 6, error: "", cancelSuccess: "", myBookings: [] })}
              style={{ display: "block", margin: "20px auto 0", background: "none", border: "none", color: GRAY_600, fontSize: "14px", cursor: "pointer", padding: "10px", WebkitTapHighlightColor: "transparent" }}
            >
              Manage existing bookings
            </button>
          )}

          {step === 6 && (
            <button
              type="button"
              onClick={this.resetForm}
              style={{ display: "block", margin: "16px auto 0", background: "none", border: "none", color: ACCENT, fontSize: "14px", fontWeight: "600", cursor: "pointer", padding: "10px", WebkitTapHighlightColor: "transparent" }}
            >
              &larr; Book a new visit
            </button>
          )}

          {/* ═══════════ What to expect ═══════════ */}
          <div style={{ marginTop: "48px" }}>
            <h3 style={{ fontSize: "19px", fontWeight: "700", color: GRAY_900, textAlign: "center", marginBottom: "24px", letterSpacing: "-0.3px" }}>What to expect on the day</h3>

            {[
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
                title: "Arrival & check-in",
                text: "When you arrive at QikTruck HQ, head to reception on the ground floor. Give your name and booking reference, and we'll get you signed in within a few minutes.",
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>,
                title: "Your consultation",
                text: "A QikTruck representative will meet you for a one-on-one session. Bring your ID, driver's licence, and any vehicle documents so we can assist you efficiently.",
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
                title: "Duration",
                text: "Most visits take between 20 and 45 minutes, depending on your query. Complex registration or compliance cases may take a little longer.",
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
                title: "What we can help with",
                text: "Account setup, vehicle onboarding, payment queries, compliance checks, training sessions, and general platform support — all handled face-to-face.",
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
                title: "Running late or need to cancel?",
                text: "No problem — use the \"Manage existing bookings\" link above to cancel and rebook. You can also reach us at support@qiktruck.co.za if anything changes.",
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
                title: "Parking & access",
                text: "Free parking is available on-site for both cars and trucks. The office is accessible from the main road entrance — follow signs for \"Driver Services\".",
              },
            ].map((item, i) => (
              <div key={i} style={{ display: "flex", gap: "16px", marginBottom: "24px", alignItems: "flex-start" }}>
                <span style={{ width: "44px", height: "44px", borderRadius: "12px", background: ACCENT_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  {item.icon}
                </span>
                <div style={{ flex: 1 }}>
                  <h4 style={{ margin: "0 0 4px", fontSize: "15px", fontWeight: "700", color: GRAY_900 }}>{item.title}</h4>
                  <p style={{ margin: 0, fontSize: "14px", color: GRAY_600, lineHeight: "1.55" }}>{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* ═══════════ Office hours banner ═══════════ */}
          <div style={{ marginTop: "16px", background: ACCENT_LIGHT, borderRadius: RADIUS, padding: "20px 24px", textAlign: "center" }}>
            <p style={{ margin: "0 0 4px", fontSize: "15px", fontWeight: "700", color: ACCENT_DARK }}>Office hours</p>
            <p style={{ margin: 0, fontSize: "14px", color: GRAY_600 }}>Monday – Friday&ensp;&#183;&ensp;9:00 AM – 3:00 PM</p>
            <p style={{ margin: "6px 0 0", fontSize: "13px", color: GRAY_400 }}>Closed on weekends and public holidays</p>
          </div>
        </div>
      </section>
    );
  }
}

// ─── Styles ──────────────────────────────────────────────────────────────────
const labelStyle = {
  display: "block",
  marginBottom: "6px",
  fontSize: "13px",
  fontWeight: "600",
  color: GRAY_900,
  letterSpacing: "0.1px",
};

const inputStyle = {
  width: "100%",
  padding: "14px 16px",
  border: `1.5px solid ${GRAY_200}`,
  borderRadius: RADIUS_SM,
  fontSize: "16px",
  outline: "none",
  boxSizing: "border-box",
  color: GRAY_900,
  background: "#fff",
  transition: TRANSITION,
  WebkitAppearance: "none",
};

const fieldGroupStyle = {
  marginBottom: "20px",
};

const primaryBtnStyle = {
  width: "100%",
  padding: "16px",
  background: ACCENT,
  color: "#fff",
  border: "none",
  borderRadius: RADIUS,
  fontSize: "16px",
  fontWeight: "700",
  cursor: "pointer",
  marginTop: "8px",
  transition: TRANSITION,
  WebkitTapHighlightColor: "transparent",
  letterSpacing: "0.2px",
};

const secondaryBtnStyle = {
  padding: "12px 24px",
  background: ACCENT_LIGHT,
  color: ACCENT_DARK,
  border: "none",
  borderRadius: RADIUS_SM,
  fontSize: "14px",
  fontWeight: "600",
  cursor: "pointer",
  transition: TRANSITION,
  WebkitTapHighlightColor: "transparent",
};

const ghostBtnStyle = {
  width: "100%",
  padding: "14px",
  background: "transparent",
  color: GRAY_600,
  border: `1.5px solid ${GRAY_200}`,
  borderRadius: RADIUS,
  fontSize: "15px",
  fontWeight: "600",
  cursor: "pointer",
  transition: TRANSITION,
  WebkitTapHighlightColor: "transparent",
};

const stepHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: "14px",
  marginBottom: "24px",
};

const stepIconStyle = {
  width: "44px",
  height: "44px",
  borderRadius: "12px",
  background: ACCENT_LIGHT,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const stepTitleStyle = {
  margin: 0,
  fontSize: "18px",
  fontWeight: "700",
  color: GRAY_900,
  letterSpacing: "-0.2px",
};

const stepSubStyle = {
  margin: "2px 0 0",
  fontSize: "14px",
  color: GRAY_600,
};

const errorBannerStyle = {
  background: "rgba(231,76,60,0.08)",
  border: "1px solid rgba(231,76,60,0.2)",
  borderRadius: RADIUS_SM,
  padding: "12px 16px",
  color: "#c0392b",
  fontSize: "14px",
  marginBottom: "4px",
};

const spinnerStyle = {
  width: "32px",
  height: "32px",
  border: `3px solid ${GRAY_200}`,
  borderTopColor: ACCENT,
  borderRadius: "50%",
  animation: "spin 0.7s linear infinite",
  margin: "0 auto",
};

const spinnerStyleSmall = {
  width: "18px",
  height: "18px",
  border: `2.5px solid rgba(255,255,255,0.3)`,
  borderTopColor: "#fff",
  borderRadius: "50%",
  animation: "spin 0.7s linear infinite",
  display: "inline-block",
};

export default BookingSection;
